import * as React from 'react';
export const cashSvg = React.forwardRef(function cashSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 0h1024v1024H0z',
      fill: '#efece6',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M447.258 624.95c-37.273 0-70.622-8.092-100.048-24.277-28.935-16.184-51.74-38.253-68.414-66.207-16.184-28.445-24.276-60.078-24.276-94.898s8.092-66.208 24.276-94.162c16.674-28.445 39.479-50.759 68.414-66.944 29.426-16.184 62.775-24.276 100.048-24.276h21.333v-83.863h86.806v83.863h214.071v82.392H443.579c-30.897 0-56.399 9.809-76.506 29.426-20.108 19.617-30.162 44.138-30.162 73.564s10.054 53.947 30.162 73.564c20.107 19.617 45.609 29.426 76.506 29.426H581.88c13.241 0 23.786 3.923 31.633 11.77 7.846 7.847 11.77 17.655 11.77 29.426 0 11.77-3.924 21.578-11.77 29.425-7.847 7.847-18.392 11.771-31.633 11.771zM254.52 686.743h325.889c30.897 0 56.399-9.808 76.506-29.425 20.108-19.617 30.162-44.139 30.162-73.564 0-29.426-10.054-53.947-30.162-73.564-20.107-19.618-45.609-29.426-76.506-29.426H442.108c-13.241 0-23.786-3.924-31.633-11.77-7.846-7.847-11.77-17.656-11.77-29.426s3.924-21.579 11.77-29.426c7.847-7.847 18.392-11.77 31.633-11.77H576.73c37.273 0 70.377 8.092 99.312 24.276 29.426 16.184 52.231 38.499 68.415 66.944 16.674 27.954 25.011 59.341 25.011 94.162 0 34.82-8.337 66.453-25.011 94.897-16.184 27.955-38.989 50.024-68.415 66.208-28.935 16.184-62.039 24.276-99.312 24.276h-21.333v83.863h-86.806v-83.863H254.52z',
      fill: '#1c1a17',
    }),
  );
});
cashSvg.defaultProps = {
  fill: 'none',
  height: '1024',
  viewBox: '0 0 1024 1024',
  width: '1024',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cash = {
  category: 'brand',
  colorable: false,
  name: 'cash',
  svg: cashSvg,
};
